
const newModel = () => {
    return {
        baocaoKehoachvonId: null,
        ten: null,
        ngayBaocao: null,
        ghiChu: null,
        stt: null,
        enabled: null,
        enabledDisplay: null,
    }
}

const newFEModel = () => {
    return {
        baocaoKehoachvonId: null,
        ten: null,
        ngayBaocao: null,
        ghiChu: null,
        stt: null,
        enabled: null,
        enabledDisplay: null,
    }
}

const fromJson = (item) => {
    return {
        baocaoKehoachvonId: item.baocaoKehoachvonId,
        ten: item.ten,
        ngayBaocao: item.ngayBaocao,
        ghiChu: item.ghiChu,
        stt: item.stt,
        enabled: item.enabled,
        enabledDisplay: item.enabled == 1 ? true : false
    }
}

const parseModeltoFEModel = (item) => {
    return {
        baocaoKehoachvonId: item.baocaoKehoachvonId,
        ten: item.ten,
        ngayBaocao: item.ngayBaocao,
        ghiChu: item.ghiChu,
        stt: item.stt,
        enabled: item.enabled,
        enabledDisplay: item.enabled == 1 ? true : false
    }
}

const newPagingSearchModel = () => {
    return {
        baocaoKehoachvonId: null,
        ten: null,
        ngayBaocaoTungay: null,
        ngayBaocaoDenngay: null,
        ghiChu: null,
        enabled: null,
    }

}

const newSearchModel = (item) => {
    return {
        baocaoKehoachvonId: item.baocaoKehoachvonId,
        ten: item.ten,
        ngayBaocaoTungay: item.ngayBaocaoTungay,
        ngayBaocaoDenngay: item.ngayBaocaoDenngay,
        ghiChu: item.ghiChu,
        enabled: item.enabled,
    }
}

const errors = () => {
    return {
        baocaoKehoachvonId: null,
        ten: null,
        ngayBaocao: null,
        ghiChu: null,
        stt: null,
        enabled: null,
        enabledDisplay: null
    }
}

export const baocaoKehoachvonModel = {
    newModel,
    newFEModel,
    parseModeltoFEModel,
    newPagingSearchModel,
    newSearchModel,
    fromJson,
    errors,
}


